type CsvValue = string | number | boolean | null | undefined;
type CsvRow = Record<string, CsvValue>;

interface CsvHeader<T extends CsvRow> {
  key: keyof T;
  label: string;
}

interface ExportToCsvParams<T extends CsvRow> {
  fileName: string;
  headers: CsvHeader<T>[];
  rows: T[];
}

const useExportToCsv = () => {
  const escapeCsvValue = (value: CsvValue): string => {
    if (value === null || value === undefined) {
      return '';
    }

    const stringValue = String(value);
    return `"${stringValue.replace(/"/g, '""')}"`;
  };

  const exportToCsv = <T extends CsvRow>({ fileName, headers, rows }: ExportToCsvParams<T>) => {
    const headerLine = headers.map((header) => escapeCsvValue(header.label)).join(',');
    const dataLines = rows.map((row) => headers.map((header) => escapeCsvValue(row[header.key])).join(','));

    const csv = [headerLine, ...dataLines].join('\n');
    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);

    link.href = url;
    link.setAttribute('download', `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  return { exportToCsv };
};

export default useExportToCsv;